import { isSupportedLocale, type SupportedLocale } from '../../../i18n/types'
import type FamilyPortalAPIClient from '../../auth/FamilyPortalAPIClient'

const PREFERENCES_PATH = '/profile/preferences'

export type GetPreferencesResult = { available: true; language: SupportedLocale | null } | { available: false }

export async function getPreferences(client: FamilyPortalAPIClient): Promise<GetPreferencesResult> {
  const res = await client.get(PREFERENCES_PATH, undefined, true, undefined, true)

  if (res.status === 404 || res.status === 401 || res.status === 403) {
    return { available: false }
  }

  if (!res.ok) {
    throw new Error(`GET ${PREFERENCES_PATH} failed with status ${res.status}`)
  }

  const data = (await res.json().catch(() => ({}))) as { language?: unknown }
  const language = isSupportedLocale(data.language) ? data.language : null
  return { available: true, language }
}

export async function patchPreferences(
  client: FamilyPortalAPIClient,
  language: SupportedLocale
): Promise<SupportedLocale> {
  const res = await client.patch(PREFERENCES_PATH, { language })

  if (!res.ok) {
    const detail = await res
      .json()
      .then((body: { detail?: unknown }) => (typeof body?.detail === 'string' ? body.detail : null))
      .catch(() => null)
    throw new Error(detail ?? `PATCH ${PREFERENCES_PATH} failed with status ${res.status}`)
  }

  const data = (await res.json().catch(() => ({}))) as { language?: unknown }
  if (!isSupportedLocale(data.language)) {
    throw new Error(`PATCH ${PREFERENCES_PATH} returned unsupported language: ${String(data.language)}`)
  }
  return data.language
}
